var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.apiErrors.length > 0
        ? _vm._l(_vm.apiErrors, function(error) {
            return _c(
              "div",
              { key: error.message, staticClass: "mb-2" },
              [
                _c(
                  "vs-alert",
                  { attrs: { color: "danger", icon: "new_releases" } },
                  [_c("span", [_vm._v(_vm._s(error))])]
                )
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-full mb-3" },
        [
          _c("vs-input", {
            staticClass: "w-full",
            attrs: {
              label: _vm.$t("addressBook.findAddressBook"),
              placeholder: _vm.$t("form.enter", {
                attribute: _vm.$t("attribute.keyword")
              }),
              "icon-no-border": "",
              icon: "icon icon-search",
              "icon-pack": "feather"
            },
            model: {
              value: _vm.keyword,
              callback: function($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.keyword,
              expression: "keyword"
            }
          ],
          staticClass: "mb-3"
        },
        [
          _c(
            "i18n",
            {
              attrs: {
                path: "addressBook.searching",
                tag: "label",
                for: "searching"
              }
            },
            [
              _c("span", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.keyword))
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "address-book-list" } },
        [
          _vm.addressBooks.length > 0
            ? _vm._l(_vm.compAddressBooks, function(groupedBooks, alphabet) {
                return _c(
                  "div",
                  { key: "address_book_" + alphabet },
                  [
                    _c("h3", { staticClass: "font-bold" }, [
                      _vm._v(_vm._s(alphabet))
                    ]),
                    _vm._v(" "),
                    _c("vs-divider", { staticClass: "my-2" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "vx-row mx-auto mb-2 w-full" },
                      _vm._l(groupedBooks, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: "address_book_item_" + index,
                            staticClass:
                              "vx-col w-full md:w-1/2 p-3 cursor-pointer hover:bg-grey-light rounded-lg",
                            on: {
                              click: function($event) {
                                return _vm.onClickSelectAddressBook(item)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "font-bold",
                                class: { "text-primary": item.favorite }
                              },
                              [
                                _vm._v(
                                  "\n              " + _vm._s(item.name) + " "
                                ),
                                item.favorite
                                  ? _c("vs-icon", {
                                      attrs: { icon: "star", color: "warning" }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(item.contact_no))]),
                            _vm._v(" "),
                            _c("small", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.address) +
                                  " " +
                                  _vm._s(
                                    item.unit
                                      ? ", Unit: " + item.unit + " - "
                                      : ""
                                  ) +
                                  " " +
                                  _vm._s(item.postal_code) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-row-reverse mt-2" },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    staticClass: "px-2",
                                    attrs: {
                                      size: "small",
                                      type: "flat",
                                      "icon-pack": "feather",
                                      icon: "icon-trash"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.onClickRemoveAddressBook(
                                          item
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("action.remove").toUpperCase()
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              })
            : [
                _c("div", { staticClass: "vx-col w-full" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _c("i", [
                      _vm._v(
                        "--- " +
                          _vm._s(
                            _vm.$t("general.notAvailable", {
                              msg: _vm.capitalizeFirstLetter(
                                _vm.$t("attribute.addressBook")
                              )
                            })
                          ) +
                          " ---"
                      )
                    ])
                  ])
                ])
              ]
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }